import { clone } from 'ramda';

export const nullsToStrings = (dataObj) => {
  if (!dataObj) {
    return dataObj;
  }
  // TODO: create a helper.
  
  const clonedObj = clone(dataObj);
  
  Object.keys(clonedObj)
    .map(key => {
      const value = clonedObj[key],
            type = typeof(value);

      if (key.substr(0, 5) === 'i18n_') {
        clonedObj[key] = JSON.parse(clonedObj[key]);
      } else if (value !== null && type === 'object') {
        // TODO array
        clonedObj[key] = nullsToStrings(clonedObj[key]);
      } else if (clonedObj[key] === null) {
        clonedObj[key] = '';
      }

      return key;
    });

  return clonedObj;
};

export const stringsToNulls = (dataObj) => {
  
  const clonedObj = clone(dataObj);
  
  Object.keys(clonedObj)
    .map(key => {
      const value = clonedObj[key],
            type = typeof(value);

      // TODO this is ugly/manual quick hack. Make it dynamic/nice.
      if (key.substr(0, 5) === 'i18n_') {
        // no empty strings allowed in JSON
        if (!clonedObj[key].et) {
          delete clonedObj[key].et;
        }
        if (!clonedObj[key].en) {
          delete clonedObj[key].en;
        }
        clonedObj[key] = JSON.stringify(clonedObj[key]);
      }  else if (value !== null && type === 'object') {
        // TODO array
        clonedObj[key] = stringsToNulls(clonedObj[key]);
      } else if (clonedObj[key] === '') {
        clonedObj[key] = null;
      }
      
      return key;
    });

  return clonedObj;
};


export const fromDynamoJson = (item) => {
  for (let key in item) {
    let val = item[key];
    
    if (typeof(val) === 'object' && key === 'M') {
      item = fromDynamoJson(val);
    } else if (typeof(val) === 'object') {
      item[key] = fromDynamoJson(val);
    } else if (val) {
      item = val;
    }
  }
  return item;
}



// WEBPACK FOOTER //
// ./src/common/utils/dynamodb.js